export default __webpack_public_path__ + "static/Noroutine_Website_Privacy_Notice-0b5c2980da295dbc8bc417c96be7a977.pdf";